export default "__VITE_ASSET__lBoavxGh__"